var React = require('react');

function LetterInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.5","y":"0.5","width":"22","height":"14","rx":"1.5","key":0}),React.createElement("path",{"d":"M0.5 2.5L10.717 8.40818C11.3483 8.77322 12.1282 8.76575 12.7524 8.38868L22.5 2.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M14 7.5L22.5 13","key":2}),React.createElement("path",{"d":"M9.5 7.5L0.5 13","key":3})]);
}

LetterInline.defaultProps = {"width":"23","height":"15","viewBox":"0 0 23 15","fill":"none","stroke":"#AFB2B8"};

module.exports = LetterInline;

LetterInline.default = LetterInline;
